import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});

export async function getComplianceDashboard() {
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/dashboard`, {
        method: 'GET',
       
      });

      if (!response.ok) {
        throw new Error('Failed to get compliance');
      }

      const result = await response.json();
      //console.log('Compliance fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching compliance:', error);
      throw new Error('Error fetching compliance');
    }

}


export async function getComplianceForEachStandardDashboard() {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/compliance-counts`, {
      method: 'GET',
    
    });

    if (!response.ok) {
      throw new Error('Failed to get compliance');
    }

    const result = await response.json();
    //console.log('Compliance fetched successfully:', result);
    return result;
  } catch (error) {
    console.error('Error fetching compliance:', error);
    throw new Error('Error fetching compliance');
  }

}


export async function getUsersTasksDashboard() {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/in-progress-tasks`, {
      method: 'GET',
     
  });

  if (!response.ok) {
    throw new Error('Failed to get users tasks');
  }

    const result = await response.json();
    return result;  
  } catch (error) {
    console.error('Error fetching users tasks:', error);
    throw new Error('Error fetching users tasks');
  }
}

export async function getAssessmentDashboard() {
  try {
    const response = await authService.apiCall(`${BASE_URL}/answers/assessment-dashboard`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Failed to get assessment dashboard');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching assessment dashboard:', error);
    throw new Error('Error fetching assessment dashboard');
  }
}

export async function getDetailedAssessment() {
  try {
    const response = await authService.apiCall(`${BASE_URL}/answers/detailed-assessment`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Failed to get detailed assessment');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching detailed assessment:', error);
    throw new Error('Error fetching detailed assessment');
  }
}

